// AUTO-GENERATED SQL Builder (V40 Final) for VendorPayoutAccount
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class VendorPayoutAccountSql {
  private ast = new SqlAst('VendorPayoutAccount', 'vendorPayoutAccount');
  public readonly main: any = {};

  public guid: SqlField;
  public vendorId: SqlField;
  public linkedAccountRef: SqlField;
  public status: SqlField;
  public kycStatus: SqlField;
  public bankSnapshotJson: SqlField;
  public activatedDate: SqlField;
  public accountEmail: SqlField;
  public stakeholderRef: SqlField;
  public productRef: SqlField;
  public setupStep: SqlField;
  public requirementsJson: SqlField;
  public failureReason: SqlField;
  public requestJson: SqlField;
  public lastSyncedDate: SqlField;
  public vendor: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public paymentTransferList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('vendorPayoutAccount', 'guid', '', 'id', 'vendorPayoutAccount_guid');
    this.vendorId = new SqlField('vendorPayoutAccount', 'vendorId', 'vendor', 'id', 'vendorPayoutAccount_vendor');
    this.linkedAccountRef = new SqlField('vendorPayoutAccount', 'linkedAccountRef', '', 'id', 'vendorPayoutAccount_linkedAccountRef');
    this.status = new SqlField('vendorPayoutAccount', 'status', '', 'id', 'vendorPayoutAccount_status');
    this.kycStatus = new SqlField('vendorPayoutAccount', 'kycStatus', '', 'id', 'vendorPayoutAccount_kycStatus');
    this.bankSnapshotJson = new SqlField('vendorPayoutAccount', 'bankSnapshotJson', '', 'id', 'vendorPayoutAccount_bankSnapshotJson');
    this.activatedDate = new SqlField('vendorPayoutAccount', 'activatedDate', '', 'id', 'vendorPayoutAccount_activatedDate');
    this.accountEmail = new SqlField('vendorPayoutAccount', 'accountEmail', '', 'id', 'vendorPayoutAccount_accountEmail');
    this.stakeholderRef = new SqlField('vendorPayoutAccount', 'stakeholderRef', '', 'id', 'vendorPayoutAccount_stakeholderRef');
    this.productRef = new SqlField('vendorPayoutAccount', 'productRef', '', 'id', 'vendorPayoutAccount_productRef');
    this.setupStep = new SqlField('vendorPayoutAccount', 'setupStep', '', 'id', 'vendorPayoutAccount_setupStep');
    this.requirementsJson = new SqlField('vendorPayoutAccount', 'requirementsJson', '', 'id', 'vendorPayoutAccount_requirementsJson');
    this.failureReason = new SqlField('vendorPayoutAccount', 'failureReason', '', 'id', 'vendorPayoutAccount_failureReason');
    this.requestJson = new SqlField('vendorPayoutAccount', 'requestJson', '', 'id', 'vendorPayoutAccount_requestJson');
    this.lastSyncedDate = new SqlField('vendorPayoutAccount', 'lastSyncedDate', '', 'id', 'vendorPayoutAccount_lastSyncedDate');
    this.vendor = createNavHybrid('vendorPayoutAccount', 'vendorPayoutAccount_vendor', 'Vendor');
    this.createdByUser = createNavHybrid('vendorPayoutAccount', 'vendorPayoutAccount_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('vendorPayoutAccount', 'vendorPayoutAccount_updatedByUser', 'User');
    this.paymentTransferList = createNavHybrid('vendorPayoutAccount', 'vendorPayoutAccount_paymentTransferList', 'PaymentTransfer');
    this.id = new SqlField('vendorPayoutAccount', 'id', '', 'id', 'vendorPayoutAccount_id');
    this.isDeleted = new SqlField('vendorPayoutAccount', 'isDeleted', '', 'id', 'vendorPayoutAccount_isDeleted');
    this.createdBy = new SqlField('vendorPayoutAccount', 'createdBy', '', 'id', 'vendorPayoutAccount_createdBy');
    this.createdDate = new SqlField('vendorPayoutAccount', 'createdDate', '', 'id', 'vendorPayoutAccount_createdDate');
    this.updatedBy = new SqlField('vendorPayoutAccount', 'updatedBy', '', 'id', 'vendorPayoutAccount_updatedBy');
    this.updatedDate = new SqlField('vendorPayoutAccount', 'updatedDate', '', 'id', 'vendorPayoutAccount_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:VendorPayoutAccountSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:VendorPayoutAccountSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:VendorPayoutAccountSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:VendorPayoutAccountSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:VendorPayoutAccountSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:VendorPayoutAccountSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:VendorPayoutAccountSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:VendorPayoutAccountSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:VendorPayoutAccountSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:VendorPayoutAccountSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
